module.exports = __webpack_public_path__ + "images/emoji/memo.4f4df2be4d4eb283b640.png";